module.exports = __webpack_public_path__ + "img/successful-icon.1cf6914c.svg";